// Change back to TS once old public site grunt stuff is gone
export const headerGA4Props = {
	"data-a-evt": "Navigation",
	"data-a-loc": "Header",
	"data-a-comp": "Global Nav",
};
